import prom from 'promjs';
const registry = prom();

const apiRequestsTimer = registry.create('histogram', 'api_requests_duration_seconds');

// 测试
// const url = 'http://metrics.ads.lilith.sh/metrics/job/dap-web';
// 生产
const url = 'https://dap-metrics.lilith.sh/metrics/job/dap-web';


// 每次进入页面上报一次
const recordPageRequest = (params) => {
    const pageRequestsCounter = registry.create('counter', 'page_requests_total');
    pageRequestsCounter.inc(params);
    report();
};

// 每隔一段时间上报一次
const recordPageDuration = (time, params) => {
    const foo = registry.create('histogram', 'page_retention_seconds');
    foo.observe(time, params);
    report();
};

// 上报
const report = () => {
    const stringData = registry.metrics();
    const flag = navigator.sendBeacon(url, stringData);
    if (flag) {
        registry.clear();
    }
};

const apiReport = (response = {}, oldTime) => {
    const responseTime = (performance.now() - oldTime) / 1000;
    apiRequestsTimer.observe(responseTime, {
        url: response.config.url,
        status: response.status,
        host: window.location.host,
    });
};


const httpErrorReport = (error = {}, oldTime) => {
    // api 超时，手动上报 http code
    const responseTime = (performance.now() - oldTime) / 1000;
    apiRequestsTimer.observe(responseTime, {
        url: error.response.config.url,
        status: error.response.status,
        host: window.location.host,
    });
    report();
};

const Metrics = {
    recordPageRequest,
    recordPageDuration,
    report,
    apiRequestsTimer,

    apiReport,
    httpErrorReport,
};

export default Metrics;
